module.exports = __webpack_public_path__ + "img/sy-logo.f0d7e405.png";